import React from 'react'
import style from "./TermAndPolicy.module.css"
import SlideUpWrapper from '../../components/Transitions/SlideUpWrapper'
import { useLocation, useNavigate } from 'react-router-dom'
import API from "../../ApiConfig"
import { ACCEPT_TERMS } from '../../Utils/constant'
import cogoToast from 'cogo-toast-react-17-fix'


const TermAndPolicy = () => {  
    const navigate=useNavigate();
    const url=localStorage.getItem("Url") 

    const location=useLocation()
    const user_data=location.state



    console.log(user_data);
    
    

    const handleNavigate=(e)=>{
        e.preventDefault()
        let apiData={
            ...(user_data.user_type=="issuer"?{issuer_id:user_data.user_id}:{verifier_id:user_data.user_id}),
        }
        API.put(ACCEPT_TERMS,apiData)
        .then(res=>{
            if(res.data.status==200){
                cogoToast.success(res.data.data.message)
                navigate(url)                
            }
        })  
        .catch(err=>{
            cogoToast.error("Something went wrong")
        })    
    }
    
    const representation=[
        {
        points:"You have a specific and permissible purpose to access this data."
        },
        {
        points:"You have obtained prior written authorization from the Individual to verify his/her details for employment purpose. You will maintain and produce the written authorization of the individual in case of any dispute on verification via AuthNumber."},
        {points:"You have maintained and will produce separate authorizations of the same individual in more than one employer verifications conducted on AuthNumber."},
        {points:"Service is provided to you solely on condition that the data provided will be used only for the specific purpose for which the consent is received from the individual. Any usage of data for any other purpose is prohibited."}

    ]
  return (
    <SlideUpWrapper>
        <div className={style.TermAndPolicy}>
            <div className={style.authnumberParent}>
                                            <img className={style.subtractIcon} loading="eager" alt="" src="/Header_icon.svg" />

                                            <img className={style.authnumberIcon} loading="eager" alt="" src="/authnumber_1.svg" />
                                        </div>
            <div className={style.TermsandPolicyBox}>
                <div>
                    <h1 className={style.TermAndPolicyHeading}>Term Of Use For AuthNumber</h1>
                </div>
                <div>

                    <div><h3 className={style.heading}>Last Revision Date:01/01/2024</h3></div>
                </div>
                <div>
                    <div>
                        <h2 className={style.heading}>Introduction</h2>
                    </div>

                    <div>
                        <p className={style.paragraph}>These “Terms of Use” govern this central repository "AuthNumber", a product of AuthBridge Research Services Private Limited that provides services to verify information for employment purpose.</p>
                        <p className={style.paragraph}>These shall be in addition to the clauses covered in Service Agreement with the verifier. In case the same are not acceptable, please do not access or use this facility. The acceptance of these terms of use as mentioned below is a prerequisite for availing this facility.</p>
                    </div>
                </div>
                <div>
                    <div>
                        <h2 className={style.heading}>Represention</h2>
                    </div>

                    <div>
                        <p className={style.paragraph}>AuthBridge Research Services Private Limited has provided this verification to you conditioned on your representation that:</p>
                        <ol>
                            {representation.map((i,index)=>(
                                <li className={style.paragraph}>{i.points}</li>
                            ))}
                        </ol>
                    </div>
                </div>
                <div>
                    <div>
                        <h2 className={style.heading}>Raise an Appeal for issue with search result</h2>
                    </div>
                    <div>
                        <p className={style.paragraph}>In case a search does not provide required data, or it provides unclear data, you are allowed to raise an appeal in which a more specific search will be conducted at the backend and the most relevant data as per the search criteria will be provided. You can raise Appeal request during the search time itself, no appeal can be raised for a previously conducted search. All appeal cases would be charged at the same rate as the search except when the appeal is genuine and supported with documentary evidence from employee.</p>
                    </div>
                </div>
                <div>
                    <div>
                        <h2 className={style.heading}>No Warranties</h2>
                    </div>
                    <div>
                        <p className={style.paragraph}>
                        AuthBridge Research Services Pvt Ltd or their affiliates, officers, employees or agents are neither responsible nor liable for any inaccuracies, errors or omissions or for any loss, damage or expense, including, without limitation, any loss of profit, indirect, special, incidental or consequential loss / damages, arising out of, any access to or use of the AuthNumber or with respect to the data contained or the inability to use.
                        </p>
                        <p className={style.paragraph}>
                        Any legal claim arising out of any misinformation in the provided data should be directed towards the organization providing that data. In case of any omission or discrepancy, information in the original records with the participating firms will be final and binding.

                        </p>
                    </div>
                </div>
                <div>
                    <div>
                        <h2 className={style.heading}>Limitation of Liabilities</h2>
                    </div>
                    <div>
                        <p className={style.paragraph}>AuthBridge Research Services Pvt Ltd or their affiliates, officers, employees or agents are neither responsible nor liable for any inaccuracies, errors or omissions or for any loss, damage or expense, including, without limitation, any loss of profit, indirect, special, incidental or consequential loss / damages, arising out of, any access to or use of the AuthNumber or with respect to the data contained or the inability to use.</p>
                        <p className={style.paragraph}>Any legal claim arising out of any misinformation in the provided data should be directed towards the organization providing that data. In case of any omission or discrepancy, information in the original records with the participating firms will be final and binding.</p>
                    </div>
                </div>
                <div>
                    <div>
                        <h2 className={style.heading}>Changes to Terms of Use</h2>
                    </div>
                    <div>
                        <p className={style.paragraph}>Authbridge Research Services Pvt. Ltd. reserves the right to change or revise the Terms of Use for availing the services via Authnumber.com at any time by posting the changes on this site. AuthBridge Data Services Pvt Ltd will alert you that changes or revisions have been made by indicating on the top of this page the date it was last revised.</p>
                    </div>
                </div>
                <div>
                <div>
                    <h2 className={style.heading}>
                    Violation to Terms of Use
                    </h2>
                </div>
                <div>
                    <p className={style.paragraph}>In the event of any finding by AuthBridge Research Services Private Limited of unethical behavior, potential conflicts of interest in terms of use of data, AuthBridge Research Services Private Limited shall be entitled to terminate the Service Agreement.</p>
                </div>
                </div>
                <div>
                <div>
                    <h2 className={style.heading}>Governing Law & Jurisdiction</h2>
                </div>

                <div>
                    <p className={style.paragraph}>These Terms of Use are governed by and construed in accordance with the Indian laws and you irrevocably submit to the exclusive jurisdiction of the court in India.</p>
                    <p className={style.paragraph}>Please visit our Privacy Policy before using the Authnumber.</p>
                </div>
                </div>
            </div>
            <div>
                <div>
                    <h3>Authnumber is an expert offering from Authbridge</h3>
                </div>
                </div>
            <div className={style.Btn}>
                <div>
                    <button className='btn btn-primary' onClick={(e)=>handleNavigate(e)}>Accept</button>
                </div>
            </div>
        </div>
    </SlideUpWrapper>
  )
}

export default TermAndPolicy